import { Button } from "@carry/ui";

/**
 * 取得失敗をその場で伝えるバナー (#641)。
 *
 * 失敗を握り潰すと「0 件」やスケルトンのまま固まり、運用者は原因にも次の一手にも
 * 辿り着けない。API が返した文言 (システム設定の未登録など運用で解消できるもの) を
 * そのまま出し、再試行できる場合はボタンを添える。
 */
export function QueryErrorBanner({
  label,
  error,
  onRetry,
}: {
  /** 何の取得に失敗したか (例: 「日報」)。 */
  label: string;
  error: unknown;
  onRetry?: () => void;
}) {
  return (
    <div
      role="alert"
      style={{
        margin: "12px 32px",
        padding: "10px 14px",
        border: "0.5px solid var(--danger)",
        background: "var(--st-cancel-bg)",
        color: "var(--danger)",
        fontSize: 12,
        display: "flex",
        alignItems: "center",
        gap: 12,
      }}
    >
      <span style={{ flex: 1 }}>
        {label}の取得に失敗しました: {error instanceof Error ? error.message : String(error)}
      </span>
      {onRetry && (
        <Button type="button" variant="outline" size="sm" onClick={onRetry}>
          再試行
        </Button>
      )}
    </div>
  );
}
